import { useCallback, useState } from 'react';
import { useAppDispatch } from '../../app/hooks';
import { Account } from '../../types/account';
import { chooseAccount } from '../../app/thunks/choose-account.thunk';

export const useAccountSelection = () => {
	const [selectedAccount, setSelectedAccount] = useState<Account | null>(null);
	const [selected, setSelected] = useState<boolean>(false);

	const dispatch = useAppDispatch();

	const onAccountSelect = useCallback((account: Account) => setSelectedAccount(account), []);

	const onContinue = async () => {
		if (!selectedAccount) return;

		setSelected(true);
		await dispatch(chooseAccount(selectedAccount));
	};

	return { selectedAccount, selected, onAccountSelect, onContinue };
};
